module.exports = __webpack_public_path__ + "img/4.3e4f44ea.png";